// src/api/modules/RangeBoxGeneralApi.js
import Methods from "../methods";

/**
 * Lista rango con cajas pendientes de recojo por cliente y orden (opcional)
 */
const listPendingRangeBox = (context, idClient, idOrder) => {
  if (!idClient) {
    console.error("idClient es obligatorio para listPendingRangeBox");
    return Promise.reject(new Error("idClient es obligatorio"));
  }

  const params = [`idClient=${idClient}`];
  if (idOrder) params.push(`idOrderGeneral=${idOrder}`);

  const url = `/rangeBox/pending?${params.join("&")}`;
  return Methods.doGet(context, url, null);
};

export default {
  listPendingRangeBox,
};



// WEBPACK FOOTER //
// ./src/api/modules/RangeBoxGeneralApi.js